export enum MimeType {
  ApplicationJson = 'application/json',
}

export const contentTypeMimeType = (contentType: string): string => {
  const semi = contentType.indexOf(';');
  return semi === -1 ? contentType : contentType.slice(0, semi);
};
